/**
 * @default 创建授权链接
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
// import { commentSaveErrHandle } from '_aaaa/errorHandle';

export interface IInput {
    data: string;
}

export const userTempprivilege = (param: IInput): string => {
    return fetchData(Api.USER_TEMPPRIVILEGE, param, { silent: true })
        .then((res: IResponse<string>) => {
            if (res.error_code) {
                // commentSaveErrHandle(res.error_code, res.error_message);
            }
            return res.data;
        })
        .catch(() => {
            return { data: { status: 0 } };
        });
};

export const getToken = () => {
    return fetchData(Api.GET_TOKEN, { silent: true })
        .then((res: IResponse<string>) => {
            if (res.error_code) {
                // commentSaveErrHandle(res.error_code);
            }
            return res.data;
        })
        .catch(() => {
            return { data: { status: 0 } };
        });
};
